
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { EasyEvent, normalizeEventPosition } from "@/util/easy-event";

@Component
export default class Dropdown extends Vue {
  // Drag
  width!: number;
  height!: number;

  windowWidth!: number;
  windowHeight!: number;

  startX!: number;
  startY!: number;

  elStartX!: number;
  elStartY!: number;

  easyEvent = new EasyEvent();
  menu!: HTMLElement | null;

  updatePosition(elem: HTMLElement, { x, y }: { x: number; y: number }) {
    elem.style.left = `${x}px`;
    elem.style.top = `${y}px`;
  }

  onDragStart(event: MouseEvent) {
    const target = event.target as HTMLElement;
    this.menu = target.closest(".v-menu__content");

    if (!this.menu) return;

    const { x, y } = normalizeEventPosition(event);
    const rect = this.menu.getBoundingClientRect();

    this.width = rect.width;
    this.height = rect.height;

    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;

    this.startX = x;
    this.startY = y;

    this.elStartX = rect.left;
    this.elStartY = rect.top;

    this.easyEvent.on("mousemove", this.onDragMove);
    this.easyEvent.on("mouseup", this.onDragEnd);
  }

  onDragMove(event: MouseEvent) {
    event.preventDefault();

    const { x, y } = normalizeEventPosition(event);

    const maxX = this.windowWidth - this.width;
    const maxY = this.windowHeight - this.height;

    const newX = Math.min(Math.max(this.elStartX + x - this.startX, 0), maxX);
    const newY = Math.min(Math.max(this.elStartY + y - this.startY, 0), maxY);

    if (!this.menu) return;
    this.updatePosition(this.menu, { x: newX, y: newY });
  }

  onDragEnd(event: MouseEvent) {
    event.preventDefault();

    this.easyEvent.off("mousemove", this.onDragMove);
    this.easyEvent.off("mouseup", this.onDragEnd);
  }
}
